import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions, TCustomUseQueryMeta } from 'core/query/type'
import {
  TPostV3LoginParams,
  TPostV3LoginResponse,
  postV3Login,
  TPostV3ModifyPwdParams,
  TPostV3ModifyPwdResponse,
  postV3ModifyPwd,
  TPostV3SetTradePwdParams,
  TPostV3SetTradePwdResponse,
  postV3SetTradePwd,
  TGetGetFuzzyInfoParams,
  TGetGetFuzzyInfoResponse,
  getGetFuzzyInfo,
  TPostV3ResetTradePwdParams,
  TPostV3ResetTradePwdResponse,
  postV3ResetTradePwd,
  TPostResetLoginPwdParams,
  TPostResetLoginPwdResponse,
  postResetLoginPwd,
  TPostResetLoginPwdCheck1Params,
  TPostResetLoginPwdCheck1Response,
  postResetLoginPwdCheck1,
  TPostResetLoginPwdCheck2Params,
  TPostResetLoginPwdCheck2Response,
  postResetLoginPwdCheck2,
  TGetV3GetBehaviorVerifyModelParams,
  TGetV3GetBehaviorVerifyModelResponse,
  getV3GetBehaviorVerifyModel,
  TPostV3VerifyImageParams,
  TPostV3VerifyImageResponse,
  postV3VerifyImage,
  TGetV3BalanceParams,
  TGetV3BalanceResponse,
  getV3Balance,
  TPostV3LoginGestureFingerprintsParams,
  TPostV3LoginGestureFingerprintsResponse,
  postV3LoginGestureFingerprints,
  TGetPushParams,
  TGetPushResponse,
  getPush,
  TPostV3VerifyImage4LoginParams,
  TPostV3VerifyImage4LoginResponse,
  postV3VerifyImage4Login,
  TGetTestParams,
  TGetTestResponse,
  getTest,
  TGetV3CurrencyUserWalletTotalParams,
  TGetV3CurrencyUserWalletTotalResponse,
  getV3CurrencyUserWalletTotal,
  TPostV2ResetLoginPwdCheck2Params,
  TPostV2ResetLoginPwdCheck2Response,
  postV2ResetLoginPwdCheck2,
  TPostV2SafetyItemApplyParams,
  TPostV2SafetyItemApplyResponse,
  postV2SafetyItemApply,
  TGetV2SafetyItemApplyCheckAccountParams,
  TGetV2SafetyItemApplyCheckAccountResponse,
  getV2SafetyItemApplyCheckAccount,
  TPostV4LoginGestureFingerprintsParams,
  TPostV4LoginGestureFingerprintsResponse,
  postV4LoginGestureFingerprints,
  TPostV4RegisterCheck2Params,
  TPostV4RegisterCheck2Response,
  postV4RegisterCheck2,
  TGetCmsDetailCmsSupportParams,
  TGetCmsDetailCmsSupportResponse,
  getCmsDetailCmsSupport,
  TGetCmsSearchCmsParams,
  TGetCmsSearchCmsResponse,
  getCmsSearchCms,
  TGetCmsSelectCalalogParams,
  TGetCmsSelectCalalogResponse,
  getCmsSelectCalalog,
  TGetCmsSelectCalalogListParams,
  TGetCmsSelectCalalogListResponse,
  getCmsSelectCalalogList,
  TGetCmsUpCmsSupportParams,
  TGetCmsUpCmsSupportResponse,
  getCmsUpCmsSupport,
  TPostJcallbackParams,
  TPostJcallbackResponse,
  postJcallback,
  TGetCareersParams,
  TGetCareersResponse,
  getCareers,
  TGetCareersPositionParams,
  TGetCareersPositionResponse,
  getCareersPosition,
  TGetSecurityGoogleUrlParams,
  TGetSecurityGoogleUrlResponse,
  getSecurityGoogleUrl,
  TPostCloseSafetyPrecheckParams,
  TPostCloseSafetyPrecheckResponse,
  postCloseSafetyPrecheck,
  TGetV4GetBehaviorVerifyModelParams,
  TGetV4GetBehaviorVerifyModelResponse,
  getV4GetBehaviorVerifyModel,
  TPostV4VerifyImageParams,
  TPostV4VerifyImageResponse,
  postV4VerifyImage,
  TPostV4VerifyImage4LoginParams,
  TPostV4VerifyImage4LoginResponse,
  postV4VerifyImage4Login,
  TGetV4BalanceParams,
  TGetV4BalanceResponse,
  getV4Balance,
  TGetV2GetSecuritySettingParams,
  TGetV2GetSecuritySettingResponse,
  getV2GetSecuritySetting,
  TGetV1SecurityQueryAccountParams,
  TGetV1SecurityQueryAccountResponse,
  getV1SecurityQueryAccount,
  TPostV1SecurityDeleteAccountParams,
  TPostV1SecurityDeleteAccountResponse,
  postV1SecurityDeleteAccount,
  TPostV2EditPhotoParams,
  TPostV2EditPhotoResponse,
  postV2EditPhoto,
  TPostV2EditNftPhotoParams,
  TPostV2EditNftPhotoResponse,
  postV2EditNftPhoto,
  TGetUserEditPhotoCheckParams,
  TGetUserEditPhotoCheckResponse,
  getUserEditPhotoCheck,
  TGetV1AccountOverviewParams,
  TGetV1AccountOverviewResponse,
  getV1AccountOverview,
  TGetStartScreenParams,
  TGetStartScreenResponse,
  getStartScreen,
  TPostSendValidCodeAddBlackListParams,
  TPostSendValidCodeAddBlackListResponse,
  postSendValidCodeAddBlackList,
  TPostSendValidCodeGetBlackListParams,
  TPostSendValidCodeGetBlackListResponse,
  postSendValidCodeGetBlackList,
  TPostV1SendValidCodeParams,
  TPostV1SendValidCodeResponse,
  postV1SendValidCode,
  TPostV5GetBehaviorVerifyModelParams,
  TPostV5GetBehaviorVerifyModelResponse,
  postV5GetBehaviorVerifyModel,
  TPostV1GetAppLatestVersionParams,
  TPostV1GetAppLatestVersionResponse,
  postV1GetAppLatestVersion,
  TPostTestV1GetAppLatestVersionParams,
  TPostTestV1GetAppLatestVersionResponse,
  postTestV1GetAppLatestVersion,
  TPostV1AccountPrecheckParams,
  TPostV1AccountPrecheckResponse,
  postV1AccountPrecheck,
  TPostV4RegisterCheck1Params,
  TPostV4RegisterCheck1Response,
  postV4RegisterCheck1,
  TGetPublicPopularCryptosParams,
  TGetPublicPopularCryptosResponse,
  getPublicPopularCryptos,
  TGetUserGetPreferenceSettingParams,
  TGetUserGetPreferenceSettingResponse,
  getUserGetPreferenceSetting,
  TPostUserModifyPreferenceSettingParams,
  TPostUserModifyPreferenceSettingResponse,
  postUserModifyPreferenceSetting,
  TPostUserApplyAccessTokenParams,
  TPostUserApplyAccessTokenResponse,
  postUserApplyAccessToken,
  TPostUserLogoutParams,
  TPostUserLogoutResponse,
  postUserLogout,
  TGetV1UserClosePopupParams,
  TGetV1UserClosePopupResponse,
  getV1UserClosePopup,
  TPostTestUserApplyAccessTokenParams,
  TPostTestUserApplyAccessTokenResponse,
  postTestUserApplyAccessToken,
  TGetV2AccountOverviewParams,
  TGetV2AccountOverviewResponse,
  getV2AccountOverview,
  TPostTestLoginParams,
  TPostTestLoginResponse,
  postTestLogin,
  TPostTestDecryptParams,
  TPostTestDecryptResponse,
  postTestDecrypt,
  TPostV1RegisterInviteCodeCheckParams,
  TPostV1RegisterInviteCodeCheckResponse,
  postV1RegisterInviteCodeCheck,
  TPostTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBpParams,
  TPostTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBpResponse,
  postTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBp,
  TGetV1UserGetPlatformInfoParams,
  TGetV1UserGetPlatformInfoResponse,
  getV1UserGetPlatformInfo,
  TPostGetDeviceIdParams,
  TPostGetDeviceIdResponse,
  postGetDeviceId,
  TGetTestGetDeviceIdParams,
  TGetTestGetDeviceIdResponse,
  getTestGetDeviceId,
  TGetV1AccountSpotParams,
  TGetV1AccountSpotResponse,
  getV1AccountSpot,
  TGetV1UserGetLoginDeviceParams,
  TGetV1UserGetLoginDeviceResponse,
  getV1UserGetLoginDevice,
  TPostV1UserRemoveLoginDeviceParams,
  TPostV1UserRemoveLoginDeviceResponse,
  postV1UserRemoveLoginDevice,
  TPostSendValidCodeAddBlackListLoginParams,
  TPostSendValidCodeAddBlackListLoginResponse,
  postSendValidCodeAddBlackListLogin,
  TPostSendValidCodeGetBlackListLoginParams,
  TPostSendValidCodeGetBlackListLoginResponse,
  postSendValidCodeGetBlackListLogin,
  TGetV1UserSyncLogUserDeviceParams,
  TGetV1UserSyncLogUserDeviceResponse,
  getV1UserSyncLogUserDevice,
  TPostResetSafetyCheckParams,
  TPostResetSafetyCheckResponse,
  postResetSafetyCheck,
  TPostResetSafetyCheckTestParams,
  TPostResetSafetyCheckTestResponse,
  postResetSafetyCheckTest,
  TPostResetSafetySubmitParams,
  TPostResetSafetySubmitResponse,
  postResetSafetySubmit,
  TPostResetSafetySubmitTestParams,
  TPostResetSafetySubmitTestResponse,
  postResetSafetySubmitTest,
  TPostUserSafetyItemApplyCheckParams,
  TPostUserSafetyItemApplyCheckResponse,
  postUserSafetyItemApplyCheck,
  TPostUserSafetyItemApplyStatusParams,
  TPostUserSafetyItemApplyStatusResponse,
  postUserSafetyItemApplyStatus,
  TPostUserSafetyItemApplySubmitParams,
  TPostUserSafetyItemApplySubmitResponse,
  postUserSafetyItemApplySubmit,
  TGetV2UserSecurityParams,
  TGetV2UserSecurityResponse,
  getV2UserSecurity,
  TGetCoinGetLatestCoinParams,
  TGetCoinGetLatestCoinResponse,
  getCoinGetLatestCoin,
  TGetCommonGetAppLatestVersionParams,
  TGetCommonGetAppLatestVersionResponse,
  getCommonGetAppLatestVersion,
  TGetCommonListArticleParams,
  TGetCommonListArticleResponse,
  getCommonListArticle,
  TGetCommonListBannerParams,
  TGetCommonListBannerResponse,
  getCommonListBanner,
  TPostSafetyItemApplyParams,
  TPostSafetyItemApplyResponse,
  postSafetyItemApply,
  TGetCurrencyListParams,
  TGetCurrencyListResponse,
  getCurrencyList,
  TPostUserSetLoginTTLParams,
  TPostUserSetLoginTTLResponse,
  postUserSetLoginTTL,
  TGetCoinGetTradePairParams,
  TGetCoinGetTradePairResponse,
  getCoinGetTradePair,
  TPostSendValidCodeParams,
  TPostSendValidCodeResponse,
  postSendValidCode,
  TPostGetGoogleKeyParams,
  TPostGetGoogleKeyResponse,
  postGetGoogleKey,
  TGetSafetyItemApplyCheckAccountParams,
  TGetSafetyItemApplyCheckAccountResponse,
  getSafetyItemApplyCheckAccount,
  TPostV3RegisterParams,
  TPostV3RegisterResponse,
  postV3Register,
  TPostV2ValidateEmailParams,
  TPostV2ValidateEmailResponse,
  postV2ValidateEmail,
  TPostV3RegisterCheck1Params,
  TPostV3RegisterCheck1Response,
  postV3RegisterCheck1,
  TPostV3RegisterCheck2Params,
  TPostV3RegisterCheck2Response,
  postV3RegisterCheck2,
  TPostModifySafetyCheckParams,
  TPostModifySafetyCheckResponse,
  postModifySafetyCheck,
  TPostValidateNewPhoneParams,
  TPostValidateNewPhoneResponse,
  postValidateNewPhone,
  TPostValidateNewEmailParams,
  TPostValidateNewEmailResponse,
  postValidateNewEmail,
  TPostCommonBindEmailParams,
  TPostCommonBindEmailResponse,
  postCommonBindEmail,
  TPostCommonBindGoogleParams,
  TPostCommonBindGoogleResponse,
  postCommonBindGoogle,
  TPostCommonBindPhoneParams,
  TPostCommonBindPhoneResponse,
  postCommonBindPhone,
  TGetUserGetSecurityLogsParams,
  TGetUserGetSecurityLogsResponse,
  getUserGetSecurityLogs,
  TPostValidateNewGoogleCodeParams,
  TPostValidateNewGoogleCodeResponse,
  postValidateNewGoogleCode,
  TGetUserGetLoginLogsParams,
  TGetUserGetLoginLogsResponse,
  getUserGetLoginLogs,
} from 'core/service/yapi/hk-web/Hotcoin/api'
// hotcoin优化相关接口
// 登录，首先不传验证码，如果调用失败加验证码继续调用此接口
export const usePostV3LoginMutation = (
  mutationOptions?: TUseMutationOptions<TPostV3LoginResponse, TPostV3LoginParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V3Login', 'Post'],
    mutationFn: (params?: TPostV3LoginParams) => postV3Login(params, mutationOptions?.meta?.requestOptions),
  })
}

// 修改登录密码
export const usePostV3ModifyPwdMutation = (
  mutationOptions?: TUseMutationOptions<TPostV3ModifyPwdResponse, TPostV3ModifyPwdParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V3ModifyPwd', 'Post'],
    mutationFn: (params?: TPostV3ModifyPwdParams) => postV3ModifyPwd(params, mutationOptions?.meta?.requestOptions),
  })
}

// 设置交易密码
export const usePostV3SetTradePwdMutation = (
  mutationOptions?: TUseMutationOptions<TPostV3SetTradePwdResponse, TPostV3SetTradePwdParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V3SetTradePwd', 'Post'],
    mutationFn: (params?: TPostV3SetTradePwdParams) => postV3SetTradePwd(params, mutationOptions?.meta?.requestOptions),
  })
}

// 通过登录名获取手机邮箱信息，手机邮箱脱敏处理
export const useGetGetFuzzyInfoQuery = (
  params?: TGetGetFuzzyInfoParams,
  options?: TUseQueryOptions<TGetGetFuzzyInfoResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'GetFuzzyInfo', 'GET', ...Object.values(params || {})],
    queryFn: () => getGetFuzzyInfo(params, options?.meta?.requestOptions),
  })
}

// 重置交易密码
export const usePostV3ResetTradePwdMutation = (
  mutationOptions?: TUseMutationOptions<TPostV3ResetTradePwdResponse, TPostV3ResetTradePwdParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V3ResetTradePwd', 'Post'],
    mutationFn: (params?: TPostV3ResetTradePwdParams) =>
      postV3ResetTradePwd(params, mutationOptions?.meta?.requestOptions),
  })
}

// 重置登录密码
export const usePostResetLoginPwdMutation = (
  mutationOptions?: TUseMutationOptions<TPostResetLoginPwdResponse, TPostResetLoginPwdParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ResetLoginPwd', 'Post'],
    mutationFn: (params?: TPostResetLoginPwdParams) => postResetLoginPwd(params, mutationOptions?.meta?.requestOptions),
  })
}

// 重置登录密码检查第一步，检查帐号是否被注册
export const usePostResetLoginPwdCheck1Mutation = (
  mutationOptions?: TUseMutationOptions<TPostResetLoginPwdCheck1Response, TPostResetLoginPwdCheck1Params> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ResetLoginPwdCheck1', 'Post'],
    mutationFn: (params?: TPostResetLoginPwdCheck1Params) =>
      postResetLoginPwdCheck1(params, mutationOptions?.meta?.requestOptions),
  })
}

// 重置登录密码检查第二步，检查验证码是否正确
export const usePostResetLoginPwdCheck2Mutation = (
  mutationOptions?: TUseMutationOptions<TPostResetLoginPwdCheck2Response, TPostResetLoginPwdCheck2Params> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ResetLoginPwdCheck2', 'Post'],
    mutationFn: (params?: TPostResetLoginPwdCheck2Params) =>
      postResetLoginPwdCheck2(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取当前行为验证模型
export const useGetV3GetBehaviorVerifyModelQuery = (
  params?: TGetV3GetBehaviorVerifyModelParams,
  options?: TUseQueryOptions<TGetV3GetBehaviorVerifyModelResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V3GetBehaviorVerifyModel', 'GET', ...Object.values(params || {})],
    queryFn: () => getV3GetBehaviorVerifyModel(params, options?.meta?.requestOptions),
  })
}

// 验证极验/图形验证码
export const usePostV3VerifyImageMutation = (
  mutationOptions?: TUseMutationOptions<TPostV3VerifyImageResponse, TPostV3VerifyImageParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V3VerifyImage', 'Post'],
    mutationFn: (params?: TPostV3VerifyImageParams) => postV3VerifyImage(params, mutationOptions?.meta?.requestOptions),
  })
}

// 用户总资产
export const useGetV3BalanceQuery = (
  params?: TGetV3BalanceParams,
  options?: TUseQueryOptions<TGetV3BalanceResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V3Balance', 'GET', ...Object.values(params || {})],
    queryFn: () => getV3Balance(params, options?.meta?.requestOptions),
  })
}

// 指纹、手势登录接口
export const usePostV3LoginGestureFingerprintsMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostV3LoginGestureFingerprintsResponse,
    TPostV3LoginGestureFingerprintsParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V3LoginGestureFingerprints', 'Post'],
    mutationFn: (params?: TPostV3LoginGestureFingerprintsParams) =>
      postV3LoginGestureFingerprints(params, mutationOptions?.meta?.requestOptions),
  })
}

// 测试推送，后面删掉
export const useGetPushQuery = (
  params?: TGetPushParams,
  options?: TUseQueryOptions<TGetPushResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'Push', 'GET', ...Object.values(params || {})],
    queryFn: () => getPush(params, options?.meta?.requestOptions),
  })
}

// 登录先验证极验/图形验证码，再验证账号密码
export const usePostV3VerifyImage4LoginMutation = (
  mutationOptions?: TUseMutationOptions<TPostV3VerifyImage4LoginResponse, TPostV3VerifyImage4LoginParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V3VerifyImage4Login', 'Post'],
    mutationFn: (params?: TPostV3VerifyImage4LoginParams) =>
      postV3VerifyImage4Login(params, mutationOptions?.meta?.requestOptions),
  })
}

// test
export const useGetTestQuery = (
  params?: TGetTestParams,
  options?: TUseQueryOptions<TGetTestResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'Test', 'GET', ...Object.values(params || {})],
    queryFn: () => getTest(params, options?.meta?.requestOptions),
  })
}

// 获取用户币币账户余额
export const useGetV3CurrencyUserWalletTotalQuery = (
  params?: TGetV3CurrencyUserWalletTotalParams,
  options?: TUseQueryOptions<TGetV3CurrencyUserWalletTotalResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V3CurrencyUserWalletTotal', 'GET', ...Object.values(params || {})],
    queryFn: () => getV3CurrencyUserWalletTotal(params, options?.meta?.requestOptions),
  })
}

// 重置登录密码检查第二步，检查验证码是否正确，添加极验等
export const usePostV2ResetLoginPwdCheck2Mutation = (
  mutationOptions?: TUseMutationOptions<TPostV2ResetLoginPwdCheck2Response, TPostV2ResetLoginPwdCheck2Params> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V2ResetLoginPwdCheck2', 'Post'],
    mutationFn: (params?: TPostV2ResetLoginPwdCheck2Params) =>
      postV2ResetLoginPwdCheck2(params, mutationOptions?.meta?.requestOptions),
  })
}

// 安全项丢失申请
export const usePostV2SafetyItemApplyMutation = (
  mutationOptions?: TUseMutationOptions<TPostV2SafetyItemApplyResponse, TPostV2SafetyItemApplyParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V2SafetyItemApply', 'Post'],
    mutationFn: (params?: TPostV2SafetyItemApplyParams) =>
      postV2SafetyItemApply(params, mutationOptions?.meta?.requestOptions),
  })
}

// 安全项丢失申请帐号检查，添加极验等
export const useGetV2SafetyItemApplyCheckAccountQuery = (
  params?: TGetV2SafetyItemApplyCheckAccountParams,
  options?: TUseQueryOptions<TGetV2SafetyItemApplyCheckAccountResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V2SafetyItemApplyCheckAccount', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2SafetyItemApplyCheckAccount(params, options?.meta?.requestOptions),
  })
}

// 指纹、手势登录接口(添加安全认证)
export const usePostV4LoginGestureFingerprintsMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostV4LoginGestureFingerprintsResponse,
    TPostV4LoginGestureFingerprintsParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V4LoginGestureFingerprints', 'Post'],
    mutationFn: (params?: TPostV4LoginGestureFingerprintsParams) =>
      postV4LoginGestureFingerprints(params, mutationOptions?.meta?.requestOptions),
  })
}

// 注册前校验第二步，添加极验等
export const usePostV4RegisterCheck2Mutation = (
  mutationOptions?: TUseMutationOptions<TPostV4RegisterCheck2Response, TPostV4RegisterCheck2Params> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V4RegisterCheck2', 'Post'],
    mutationFn: (params?: TPostV4RegisterCheck2Params) =>
      postV4RegisterCheck2(params, mutationOptions?.meta?.requestOptions),
  })
}

// 帮助中心查询正文详情
export const useGetCmsDetailCmsSupportQuery = (
  params?: TGetCmsDetailCmsSupportParams,
  options?: TUseQueryOptions<TGetCmsDetailCmsSupportResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CmsDetailCmsSupport', 'GET', ...Object.values(params || {})],
    queryFn: () => getCmsDetailCmsSupport(params, options?.meta?.requestOptions),
  })
}

// 帮助中心搜索
export const useGetCmsSearchCmsQuery = (
  params?: TGetCmsSearchCmsParams,
  options?: TUseQueryOptions<TGetCmsSearchCmsResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CmsSearchCms', 'GET', ...Object.values(params || {})],
    queryFn: () => getCmsSearchCms(params, options?.meta?.requestOptions),
  })
}

// 帮助中心查询目录
export const useGetCmsSelectCalalogQuery = (
  params?: TGetCmsSelectCalalogParams,
  options?: TUseQueryOptions<TGetCmsSelectCalalogResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CmsSelectCalalog', 'GET', ...Object.values(params || {})],
    queryFn: () => getCmsSelectCalalog(params, options?.meta?.requestOptions),
  })
}

// 帮助中心查询目录下列表
export const useGetCmsSelectCalalogListQuery = (
  params?: TGetCmsSelectCalalogListParams,
  options?: TUseQueryOptions<TGetCmsSelectCalalogListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CmsSelectCalalogList', 'GET', ...Object.values(params || {})],
    queryFn: () => getCmsSelectCalalogList(params, options?.meta?.requestOptions),
  })
}

// 帮助中心查询最新文章
export const useGetCmsUpCmsSupportQuery = (
  params?: TGetCmsUpCmsSupportParams,
  options?: TUseQueryOptions<TGetCmsUpCmsSupportResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CmsUpCmsSupport', 'GET', ...Object.values(params || {})],
    queryFn: () => getCmsUpCmsSupport(params, options?.meta?.requestOptions),
  })
}

// 注册极光推送回调
export const usePostJcallbackMutation = (
  mutationOptions?: TUseMutationOptions<TPostJcallbackResponse, TPostJcallbackParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'Jcallback', 'Post'],
    mutationFn: (params?: TPostJcallbackParams) => postJcallback(params, mutationOptions?.meta?.requestOptions),
  })
}

// 职业机会
export const useGetCareersQuery = (
  params?: TGetCareersParams,
  options?: TUseQueryOptions<TGetCareersResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'Careers', 'GET', ...Object.values(params || {})],
    queryFn: () => getCareers(params, options?.meta?.requestOptions),
  })
}

// 职位详情
export const useGetCareersPositionQuery = (
  params?: TGetCareersPositionParams,
  options?: TUseQueryOptions<TGetCareersPositionResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CareersPosition', 'GET', ...Object.values(params || {})],
    queryFn: () => getCareersPosition(params, options?.meta?.requestOptions),
  })
}

// 初始化谷歌秘钥加密--后面删除
export const useGetSecurityGoogleUrlQuery = (
  params?: TGetSecurityGoogleUrlParams,
  options?: TUseQueryOptions<TGetSecurityGoogleUrlResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'SecurityGoogleUrl', 'GET', ...Object.values(params || {})],
    queryFn: () => getSecurityGoogleUrl(params, options?.meta?.requestOptions),
  })
}

// 三项安全验证关闭前预检查
export const usePostCloseSafetyPrecheckMutation = (
  mutationOptions?: TUseMutationOptions<TPostCloseSafetyPrecheckResponse, TPostCloseSafetyPrecheckParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'CloseSafetyPrecheck', 'Post'],
    mutationFn: (params?: TPostCloseSafetyPrecheckParams) =>
      postCloseSafetyPrecheck(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取当前行为验证模型V4
export const useGetV4GetBehaviorVerifyModelQuery = (
  params?: TGetV4GetBehaviorVerifyModelParams,
  options?: TUseQueryOptions<TGetV4GetBehaviorVerifyModelResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V4GetBehaviorVerifyModel', 'GET', ...Object.values(params || {})],
    queryFn: () => getV4GetBehaviorVerifyModel(params, options?.meta?.requestOptions),
  })
}

// 验证极验/图形验证码/Google验证 V4
export const usePostV4VerifyImageMutation = (
  mutationOptions?: TUseMutationOptions<TPostV4VerifyImageResponse, TPostV4VerifyImageParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V4VerifyImage', 'Post'],
    mutationFn: (params?: TPostV4VerifyImageParams) => postV4VerifyImage(params, mutationOptions?.meta?.requestOptions),
  })
}

// 登录先验证极验/图形验证码，再验证账号密码
export const usePostV4VerifyImage4LoginMutation = (
  mutationOptions?: TUseMutationOptions<TPostV4VerifyImage4LoginResponse, TPostV4VerifyImage4LoginParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V4VerifyImage4Login', 'Post'],
    mutationFn: (params?: TPostV4VerifyImage4LoginParams) =>
      postV4VerifyImage4Login(params, mutationOptions?.meta?.requestOptions),
  })
}

// 用户总资产
export const useGetV4BalanceQuery = (
  params?: TGetV4BalanceParams,
  options?: TUseQueryOptions<TGetV4BalanceResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V4Balance', 'GET', ...Object.values(params || {})],
    queryFn: () => getV4Balance(params, options?.meta?.requestOptions),
  })
}

// 获取用户安全信息
export const useGetV2GetSecuritySettingQuery = (
  params?: TGetV2GetSecuritySettingParams,
  options?: TUseQueryOptions<TGetV2GetSecuritySettingResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V2GetSecuritySetting', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2GetSecuritySetting(params, options?.meta?.requestOptions),
  })
}

// 删除账号前置查询
export const useGetV1SecurityQueryAccountQuery = (
  params?: TGetV1SecurityQueryAccountParams,
  options?: TUseQueryOptions<TGetV1SecurityQueryAccountResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V1SecurityQueryAccount', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1SecurityQueryAccount(params, options?.meta?.requestOptions),
  })
}

// 提交删除账号申请
export const usePostV1SecurityDeleteAccountMutation = (
  mutationOptions?: TUseMutationOptions<TPostV1SecurityDeleteAccountResponse, TPostV1SecurityDeleteAccountParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V1SecurityDeleteAccount', 'Post'],
    mutationFn: (params?: TPostV1SecurityDeleteAccountParams) =>
      postV1SecurityDeleteAccount(params, mutationOptions?.meta?.requestOptions),
  })
}

// 修改用户普通头像
export const usePostV2EditPhotoMutation = (
  mutationOptions?: TUseMutationOptions<TPostV2EditPhotoResponse, TPostV2EditPhotoParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V2EditPhoto', 'Post'],
    mutationFn: (params?: TPostV2EditPhotoParams) => postV2EditPhoto(params, mutationOptions?.meta?.requestOptions),
  })
}

// 修改用户NFT头像
export const usePostV2EditNftPhotoMutation = (
  mutationOptions?: TUseMutationOptions<TPostV2EditNftPhotoResponse, TPostV2EditNftPhotoParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V2EditNftPhoto', 'Post'],
    mutationFn: (params?: TPostV2EditNftPhotoParams) =>
      postV2EditNftPhoto(params, mutationOptions?.meta?.requestOptions),
  })
}

// 检查用户是否可更新头像
export const useGetUserEditPhotoCheckQuery = (
  params?: TGetUserEditPhotoCheckParams,
  options?: TUseQueryOptions<TGetUserEditPhotoCheckResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'UserEditPhotoCheck', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserEditPhotoCheck(params, options?.meta?.requestOptions),
  })
}

// 用户总资产
export const useGetV1AccountOverviewQuery = (
  params?: TGetV1AccountOverviewParams,
  options?: TUseQueryOptions<TGetV1AccountOverviewResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V1AccountOverview', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1AccountOverview(params, options?.meta?.requestOptions),
  })
}

// 应用开屏页
export const useGetStartScreenQuery = (
  params?: TGetStartScreenParams,
  options?: TUseQueryOptions<TGetStartScreenResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'StartScreen', 'GET', ...Object.values(params || {})],
    queryFn: () => getStartScreen(params, options?.meta?.requestOptions),
  })
}

// 发送验证码(email/sms)
export const usePostSendValidCodeAddBlackListMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostSendValidCodeAddBlackListResponse,
    TPostSendValidCodeAddBlackListParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'SendValidCodeAddBlackList', 'Post'],
    mutationFn: (params?: TPostSendValidCodeAddBlackListParams) =>
      postSendValidCodeAddBlackList(params, mutationOptions?.meta?.requestOptions),
  })
}

// 发送验证码(email/sms)
export const usePostSendValidCodeGetBlackListMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostSendValidCodeGetBlackListResponse,
    TPostSendValidCodeGetBlackListParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'SendValidCodeGetBlackList', 'Post'],
    mutationFn: (params?: TPostSendValidCodeGetBlackListParams) =>
      postSendValidCodeGetBlackList(params, mutationOptions?.meta?.requestOptions),
  })
}

// 发送验证码(email/sms)加密版本
export const usePostV1SendValidCodeMutation = (
  mutationOptions?: TUseMutationOptions<TPostV1SendValidCodeResponse, TPostV1SendValidCodeParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V1SendValidCode', 'Post'],
    mutationFn: (params?: TPostV1SendValidCodeParams) =>
      postV1SendValidCode(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取当前行为验证模型V5
export const usePostV5GetBehaviorVerifyModelMutation = (
  mutationOptions?: TUseMutationOptions<TPostV5GetBehaviorVerifyModelResponse, TPostV5GetBehaviorVerifyModelParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V5GetBehaviorVerifyModel', 'Post'],
    mutationFn: (params?: TPostV5GetBehaviorVerifyModelParams) =>
      postV5GetBehaviorVerifyModel(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取最新可更新APP版本，没有则不返回(新版)
export const usePostV1GetAppLatestVersionMutation = (
  mutationOptions?: TUseMutationOptions<TPostV1GetAppLatestVersionResponse, TPostV1GetAppLatestVersionParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V1GetAppLatestVersion', 'Post'],
    mutationFn: (params?: TPostV1GetAppLatestVersionParams) =>
      postV1GetAppLatestVersion(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取最新可更新APP版本，没有则不返回(新版)
export const usePostTestV1GetAppLatestVersionMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostTestV1GetAppLatestVersionResponse,
    TPostTestV1GetAppLatestVersionParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'TestV1GetAppLatestVersion', 'Post'],
    mutationFn: (params?: TPostTestV1GetAppLatestVersionParams) =>
      postTestV1GetAppLatestVersion(params, mutationOptions?.meta?.requestOptions),
  })
}

// 检查账号是否存在
export const usePostV1AccountPrecheckMutation = (
  mutationOptions?: TUseMutationOptions<TPostV1AccountPrecheckResponse, TPostV1AccountPrecheckParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V1AccountPrecheck', 'Post'],
    mutationFn: (params?: TPostV1AccountPrecheckParams) =>
      postV1AccountPrecheck(params, mutationOptions?.meta?.requestOptions),
  })
}

// 注册前校验第一步，加密
export const usePostV4RegisterCheck1Mutation = (
  mutationOptions?: TUseMutationOptions<TPostV4RegisterCheck1Response, TPostV4RegisterCheck1Params> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V4RegisterCheck1', 'Post'],
    mutationFn: (params?: TPostV4RegisterCheck1Params) =>
      postV4RegisterCheck1(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取热门币种
export const useGetPublicPopularCryptosQuery = (
  params?: TGetPublicPopularCryptosParams,
  options?: TUseQueryOptions<TGetPublicPopularCryptosResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'PublicPopularCryptos', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicPopularCryptos(params, options?.meta?.requestOptions),
  })
}

// 查询用户偏好设置
export const useGetUserGetPreferenceSettingQuery = (
  params?: TGetUserGetPreferenceSettingParams,
  options?: TUseQueryOptions<TGetUserGetPreferenceSettingResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'UserGetPreferenceSetting', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserGetPreferenceSetting(params, options?.meta?.requestOptions),
  })
}

// 修改用户偏好设置
export const usePostUserModifyPreferenceSettingMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostUserModifyPreferenceSettingResponse,
    TPostUserModifyPreferenceSettingParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'UserModifyPreferenceSetting', 'Post'],
    mutationFn: (params?: TPostUserModifyPreferenceSettingParams) =>
      postUserModifyPreferenceSetting(params, mutationOptions?.meta?.requestOptions),
  })
}

// 使用刷新令牌申请访问Token
export const usePostUserApplyAccessTokenMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserApplyAccessTokenResponse, TPostUserApplyAccessTokenParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'UserApplyAccessToken', 'Post'],
    mutationFn: (params?: TPostUserApplyAccessTokenParams) =>
      postUserApplyAccessToken(params, mutationOptions?.meta?.requestOptions),
  })
}

// 用户退出登录
export const usePostUserLogoutMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserLogoutResponse, TPostUserLogoutParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'UserLogout', 'Post'],
    mutationFn: (params?: TPostUserLogoutParams) => postUserLogout(params, mutationOptions?.meta?.requestOptions),
  })
}

// 关闭用户弹窗
export const useGetV1UserClosePopupQuery = (
  params?: TGetV1UserClosePopupParams,
  options?: TUseQueryOptions<TGetV1UserClosePopupResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V1UserClosePopup', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1UserClosePopup(params, options?.meta?.requestOptions),
  })
}

// 使用刷新令牌申请访问Token
export const usePostTestUserApplyAccessTokenMutation = (
  mutationOptions?: TUseMutationOptions<TPostTestUserApplyAccessTokenResponse, TPostTestUserApplyAccessTokenParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'TestUserApplyAccessToken', 'Post'],
    mutationFn: (params?: TPostTestUserApplyAccessTokenParams) =>
      postTestUserApplyAccessToken(params, mutationOptions?.meta?.requestOptions),
  })
}

// 用户总资产
export const useGetV2AccountOverviewQuery = (
  params?: TGetV2AccountOverviewParams,
  options?: TUseQueryOptions<TGetV2AccountOverviewResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V2AccountOverview', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2AccountOverview(params, options?.meta?.requestOptions),
  })
}

// 登录，首先不传验证码，如果调用失败加验证码继续调用此接口
export const usePostTestLoginMutation = (
  mutationOptions?: TUseMutationOptions<TPostTestLoginResponse, TPostTestLoginParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'TestLogin', 'Post'],
    mutationFn: (params?: TPostTestLoginParams) => postTestLogin(params, mutationOptions?.meta?.requestOptions),
  })
}

// 接口解密
export const usePostTestDecryptMutation = (
  mutationOptions?: TUseMutationOptions<TPostTestDecryptResponse, TPostTestDecryptParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'TestDecrypt', 'Post'],
    mutationFn: (params?: TPostTestDecryptParams) => postTestDecrypt(params, mutationOptions?.meta?.requestOptions),
  })
}

// 邀请码检查，加密
export const usePostV1RegisterInviteCodeCheckMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostV1RegisterInviteCodeCheckResponse,
    TPostV1RegisterInviteCodeCheckParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V1RegisterInviteCodeCheck', 'Post'],
    mutationFn: (params?: TPostV1RegisterInviteCodeCheckParams) =>
      postV1RegisterInviteCodeCheck(params, mutationOptions?.meta?.requestOptions),
  })
}

// 非生产环境解密
export const usePostTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBpMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBpResponse,
    TPostTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBpParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'TestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBp', 'Post'],
    mutationFn: (params?: TPostTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBpParams) =>
      postTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBp(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取平台介绍相关信息和分享者信息
export const useGetV1UserGetPlatformInfoQuery = (
  params?: TGetV1UserGetPlatformInfoParams,
  options?: TUseQueryOptions<TGetV1UserGetPlatformInfoResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V1UserGetPlatformInfo', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1UserGetPlatformInfo(params, options?.meta?.requestOptions),
  })
}

// 获取设备ID
export const usePostGetDeviceIdMutation = (
  mutationOptions?: TUseMutationOptions<TPostGetDeviceIdResponse, TPostGetDeviceIdParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'GetDeviceId', 'Post'],
    mutationFn: (params?: TPostGetDeviceIdParams) => postGetDeviceId(params, mutationOptions?.meta?.requestOptions),
  })
}

// getDeviceInfoTest
export const useGetTestGetDeviceIdQuery = (
  params?: TGetTestGetDeviceIdParams,
  options?: TUseQueryOptions<TGetTestGetDeviceIdResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'TestGetDeviceId', 'GET', ...Object.values(params || {})],
    queryFn: () => getTestGetDeviceId(params, options?.meta?.requestOptions),
  })
}

// 获取用户现货账户列表
export const useGetV1AccountSpotQuery = (
  params?: TGetV1AccountSpotParams,
  options?: TUseQueryOptions<TGetV1AccountSpotResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V1AccountSpot', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1AccountSpot(params, options?.meta?.requestOptions),
  })
}

// 查询登录设备
export const useGetV1UserGetLoginDeviceQuery = (
  params?: TGetV1UserGetLoginDeviceParams,
  options?: TUseQueryOptions<TGetV1UserGetLoginDeviceResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V1UserGetLoginDevice', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1UserGetLoginDevice(params, options?.meta?.requestOptions),
  })
}

// 移除登录设备
export const usePostV1UserRemoveLoginDeviceMutation = (
  mutationOptions?: TUseMutationOptions<TPostV1UserRemoveLoginDeviceResponse, TPostV1UserRemoveLoginDeviceParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V1UserRemoveLoginDevice', 'Post'],
    mutationFn: (params?: TPostV1UserRemoveLoginDeviceParams) =>
      postV1UserRemoveLoginDevice(params, mutationOptions?.meta?.requestOptions),
  })
}

// 发送验证码(email/sms)
export const usePostSendValidCodeAddBlackListLoginMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostSendValidCodeAddBlackListLoginResponse,
    TPostSendValidCodeAddBlackListLoginParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'SendValidCodeAddBlackListLogin', 'Post'],
    mutationFn: (params?: TPostSendValidCodeAddBlackListLoginParams) =>
      postSendValidCodeAddBlackListLogin(params, mutationOptions?.meta?.requestOptions),
  })
}

// 发送验证码(email/sms)
export const usePostSendValidCodeGetBlackListLoginMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostSendValidCodeGetBlackListLoginResponse,
    TPostSendValidCodeGetBlackListLoginParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'SendValidCodeGetBlackListLogin', 'Post'],
    mutationFn: (params?: TPostSendValidCodeGetBlackListLoginParams) =>
      postSendValidCodeGetBlackListLogin(params, mutationOptions?.meta?.requestOptions),
  })
}

// 同步用户登录数据
export const useGetV1UserSyncLogUserDeviceQuery = (
  params?: TGetV1UserSyncLogUserDeviceParams,
  options?: TUseQueryOptions<TGetV1UserSyncLogUserDeviceResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V1UserSyncLogUserDevice', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1UserSyncLogUserDevice(params, options?.meta?.requestOptions),
  })
}

// 通过2项安全项重置第三项前置校验
export const usePostResetSafetyCheckMutation = (
  mutationOptions?: TUseMutationOptions<TPostResetSafetyCheckResponse, TPostResetSafetyCheckParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ResetSafetyCheck', 'Post'],
    mutationFn: (params?: TPostResetSafetyCheckParams) =>
      postResetSafetyCheck(params, mutationOptions?.meta?.requestOptions),
  })
}

// 通过2项安全项重置第三项前置校验
export const usePostResetSafetyCheckTestMutation = (
  mutationOptions?: TUseMutationOptions<TPostResetSafetyCheckTestResponse, TPostResetSafetyCheckTestParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ResetSafetyCheckTest', 'Post'],
    mutationFn: (params?: TPostResetSafetyCheckTestParams) =>
      postResetSafetyCheckTest(params, mutationOptions?.meta?.requestOptions),
  })
}

// 通过2项安全项重置第三项提交
export const usePostResetSafetySubmitMutation = (
  mutationOptions?: TUseMutationOptions<TPostResetSafetySubmitResponse, TPostResetSafetySubmitParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ResetSafetySubmit', 'Post'],
    mutationFn: (params?: TPostResetSafetySubmitParams) =>
      postResetSafetySubmit(params, mutationOptions?.meta?.requestOptions),
  })
}

// 通过2项安全项重置第三项提交
export const usePostResetSafetySubmitTestMutation = (
  mutationOptions?: TUseMutationOptions<TPostResetSafetySubmitTestResponse, TPostResetSafetySubmitTestParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ResetSafetySubmitTest', 'Post'],
    mutationFn: (params?: TPostResetSafetySubmitTestParams) =>
      postResetSafetySubmitTest(params, mutationOptions?.meta?.requestOptions),
  })
}

// 用户安全项丢失申请校验
export const usePostUserSafetyItemApplyCheckMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserSafetyItemApplyCheckResponse, TPostUserSafetyItemApplyCheckParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'UserSafetyItemApplyCheck', 'Post'],
    mutationFn: (params?: TPostUserSafetyItemApplyCheckParams) =>
      postUserSafetyItemApplyCheck(params, mutationOptions?.meta?.requestOptions),
  })
}

// 用户安全项丢失申请状态
export const usePostUserSafetyItemApplyStatusMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostUserSafetyItemApplyStatusResponse,
    TPostUserSafetyItemApplyStatusParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'UserSafetyItemApplyStatus', 'Post'],
    mutationFn: (params?: TPostUserSafetyItemApplyStatusParams) =>
      postUserSafetyItemApplyStatus(params, mutationOptions?.meta?.requestOptions),
  })
}

// 用户安全项丢失申请提交
export const usePostUserSafetyItemApplySubmitMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostUserSafetyItemApplySubmitResponse,
    TPostUserSafetyItemApplySubmitParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'UserSafetyItemApplySubmit', 'Post'],
    mutationFn: (params?: TPostUserSafetyItemApplySubmitParams) =>
      postUserSafetyItemApplySubmit(params, mutationOptions?.meta?.requestOptions),
  })
}

// 查询用户安全项
export const useGetV2UserSecurityQuery = (
  params?: TGetV2UserSecurityParams,
  options?: TUseQueryOptions<TGetV2UserSecurityResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'V2UserSecurity', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2UserSecurity(params, options?.meta?.requestOptions),
  })
}

// 获取最新上币
export const useGetCoinGetLatestCoinQuery = (
  params?: TGetCoinGetLatestCoinParams,
  options?: TUseQueryOptions<TGetCoinGetLatestCoinResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CoinGetLatestCoin', 'GET', ...Object.values(params || {})],
    queryFn: () => getCoinGetLatestCoin(params, options?.meta?.requestOptions),
  })
}

// 获取最新可更新APP版本，没有则不返回
export const useGetCommonGetAppLatestVersionQuery = (
  params?: TGetCommonGetAppLatestVersionParams,
  options?: TUseQueryOptions<TGetCommonGetAppLatestVersionResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CommonGetAppLatestVersion', 'GET', ...Object.values(params || {})],
    queryFn: () => getCommonGetAppLatestVersion(params, options?.meta?.requestOptions),
  })
}

// 获取公告列表
export const useGetCommonListArticleQuery = (
  params?: TGetCommonListArticleParams,
  options?: TUseQueryOptions<TGetCommonListArticleResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CommonListArticle', 'GET', ...Object.values(params || {})],
    queryFn: () => getCommonListArticle(params, options?.meta?.requestOptions),
  })
}

// 获取轮播图、登录弹窗等
export const useGetCommonListBannerQuery = (
  params?: TGetCommonListBannerParams,
  options?: TUseQueryOptions<TGetCommonListBannerResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CommonListBanner', 'GET', ...Object.values(params || {})],
    queryFn: () => getCommonListBanner(params, options?.meta?.requestOptions),
  })
}

// 安全项丢失申请
export const usePostSafetyItemApplyMutation = (
  mutationOptions?: TUseMutationOptions<TPostSafetyItemApplyResponse, TPostSafetyItemApplyParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'SafetyItemApply', 'Post'],
    mutationFn: (params?: TPostSafetyItemApplyParams) =>
      postSafetyItemApply(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取货币列表
export const useGetCurrencyListQuery = (
  params?: TGetCurrencyListParams,
  options?: TUseQueryOptions<TGetCurrencyListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CurrencyList', 'GET', ...Object.values(params || {})],
    queryFn: () => getCurrencyList(params, options?.meta?.requestOptions),
  })
}

// 保持登录时长
export const usePostUserSetLoginTTLMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserSetLoginTTLResponse, TPostUserSetLoginTTLParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'UserSetLoginTTL', 'Post'],
    mutationFn: (params?: TPostUserSetLoginTTLParams) =>
      postUserSetLoginTTL(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取主流交易对/推荐币对，走势图请调接口/kline/history
export const useGetCoinGetTradePairQuery = (
  params?: TGetCoinGetTradePairParams,
  options?: TUseQueryOptions<TGetCoinGetTradePairResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'CoinGetTradePair', 'GET', ...Object.values(params || {})],
    queryFn: () => getCoinGetTradePair(params, options?.meta?.requestOptions),
  })
}

// 发送验证码(email/sms)
export const usePostSendValidCodeMutation = (
  mutationOptions?: TUseMutationOptions<TPostSendValidCodeResponse, TPostSendValidCodeParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'SendValidCode', 'Post'],
    mutationFn: (params?: TPostSendValidCodeParams) => postSendValidCode(params, mutationOptions?.meta?.requestOptions),
  })
}

//  获取谷歌key
export const usePostGetGoogleKeyMutation = (
  mutationOptions?: TUseMutationOptions<TPostGetGoogleKeyResponse, TPostGetGoogleKeyParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'GetGoogleKey', 'Post'],
    mutationFn: (params?: TPostGetGoogleKeyParams) => postGetGoogleKey(params, mutationOptions?.meta?.requestOptions),
  })
}

// 安全项丢失申请帐号检查
export const useGetSafetyItemApplyCheckAccountQuery = (
  params?: TGetSafetyItemApplyCheckAccountParams,
  options?: TUseQueryOptions<TGetSafetyItemApplyCheckAccountResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'SafetyItemApplyCheckAccount', 'GET', ...Object.values(params || {})],
    queryFn: () => getSafetyItemApplyCheckAccount(params, options?.meta?.requestOptions),
  })
}

// 注册
export const usePostV3RegisterMutation = (
  mutationOptions?: TUseMutationOptions<TPostV3RegisterResponse, TPostV3RegisterParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V3Register', 'Post'],
    mutationFn: (params?: TPostV3RegisterParams) => postV3Register(params, mutationOptions?.meta?.requestOptions),
  })
}

// 验证新邮箱验证码
export const usePostV2ValidateEmailMutation = (
  mutationOptions?: TUseMutationOptions<TPostV2ValidateEmailResponse, TPostV2ValidateEmailParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V2ValidateEmail', 'Post'],
    mutationFn: (params?: TPostV2ValidateEmailParams) =>
      postV2ValidateEmail(params, mutationOptions?.meta?.requestOptions),
  })
}

// 注册前校验第一步
export const usePostV3RegisterCheck1Mutation = (
  mutationOptions?: TUseMutationOptions<TPostV3RegisterCheck1Response, TPostV3RegisterCheck1Params> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V3RegisterCheck1', 'Post'],
    mutationFn: (params?: TPostV3RegisterCheck1Params) =>
      postV3RegisterCheck1(params, mutationOptions?.meta?.requestOptions),
  })
}

// 注册前校验第二步
export const usePostV3RegisterCheck2Mutation = (
  mutationOptions?: TUseMutationOptions<TPostV3RegisterCheck2Response, TPostV3RegisterCheck2Params> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'V3RegisterCheck2', 'Post'],
    mutationFn: (params?: TPostV3RegisterCheck2Params) =>
      postV3RegisterCheck2(params, mutationOptions?.meta?.requestOptions),
  })
}

// 三项安全验证
export const usePostModifySafetyCheckMutation = (
  mutationOptions?: TUseMutationOptions<TPostModifySafetyCheckResponse, TPostModifySafetyCheckParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ModifySafetyCheck', 'Post'],
    mutationFn: (params?: TPostModifySafetyCheckParams) =>
      postModifySafetyCheck(params, mutationOptions?.meta?.requestOptions),
  })
}

// 修改手机
export const usePostValidateNewPhoneMutation = (
  mutationOptions?: TUseMutationOptions<TPostValidateNewPhoneResponse, TPostValidateNewPhoneParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ValidateNewPhone', 'Post'],
    mutationFn: (params?: TPostValidateNewPhoneParams) =>
      postValidateNewPhone(params, mutationOptions?.meta?.requestOptions),
  })
}

// 修改邮箱
export const usePostValidateNewEmailMutation = (
  mutationOptions?: TUseMutationOptions<TPostValidateNewEmailResponse, TPostValidateNewEmailParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ValidateNewEmail', 'Post'],
    mutationFn: (params?: TPostValidateNewEmailParams) =>
      postValidateNewEmail(params, mutationOptions?.meta?.requestOptions),
  })
}

// 绑定邮箱
export const usePostCommonBindEmailMutation = (
  mutationOptions?: TUseMutationOptions<TPostCommonBindEmailResponse, TPostCommonBindEmailParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'CommonBindEmail', 'Post'],
    mutationFn: (params?: TPostCommonBindEmailParams) =>
      postCommonBindEmail(params, mutationOptions?.meta?.requestOptions),
  })
}

// 绑定谷歌
export const usePostCommonBindGoogleMutation = (
  mutationOptions?: TUseMutationOptions<TPostCommonBindGoogleResponse, TPostCommonBindGoogleParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'CommonBindGoogle', 'Post'],
    mutationFn: (params?: TPostCommonBindGoogleParams) =>
      postCommonBindGoogle(params, mutationOptions?.meta?.requestOptions),
  })
}

// 绑定手机
export const usePostCommonBindPhoneMutation = (
  mutationOptions?: TUseMutationOptions<TPostCommonBindPhoneResponse, TPostCommonBindPhoneParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'CommonBindPhone', 'Post'],
    mutationFn: (params?: TPostCommonBindPhoneParams) =>
      postCommonBindPhone(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取安全设置记录（最近10条）
export const useGetUserGetSecurityLogsQuery = (
  params?: TGetUserGetSecurityLogsParams,
  options?: TUseQueryOptions<TGetUserGetSecurityLogsResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'UserGetSecurityLogs', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserGetSecurityLogs(params, options?.meta?.requestOptions),
  })
}

// 修改谷歌
export const usePostValidateNewGoogleCodeMutation = (
  mutationOptions?: TUseMutationOptions<TPostValidateNewGoogleCodeResponse, TPostValidateNewGoogleCodeParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Hotcoin', 'ValidateNewGoogleCode', 'Post'],
    mutationFn: (params?: TPostValidateNewGoogleCodeParams) =>
      postValidateNewGoogleCode(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取登录记录（最近10条）
export const useGetUserGetLoginLogsQuery = (
  params?: TGetUserGetLoginLogsParams,
  options?: TUseQueryOptions<TGetUserGetLoginLogsResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Hotcoin', 'UserGetLoginLogs', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserGetLoginLogs(params, options?.meta?.requestOptions),
  })
}
